import { NavLink, Outlet } from 'react-router';
import { useAuth } from '../auth/AuthProvider';
import { StepUpDialog } from '../auth/StepUpDialog';
import { Button, Icon } from '../design';
import { NAV_GROUPS } from './nav';
import s from './shell.module.css';

export function Shell() {
  const { user, has, logout } = useAuth();
  const initials = (user?.name ?? '?')
    .split(' ')
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
  return (
    <div className={s.shell}>
      <nav className={s.sidebar} aria-label="Module">
        <div className={s.brand}>
          <div className={s.brandMark}>
            <Icon name="locker" size={18} />
          </div>
          <div>
            <strong>SYNAPTIC</strong>
            <span>Smart Locker · Consolă</span>
          </div>
        </div>
        {NAV_GROUPS.map((g) => {
          const items = g.items.filter((it) => has(it.permission));
          if (items.length === 0) return null;
          return (
            <div key={g.title}>
              <div className={s.group}>{g.title}</div>
              {items.map((it) => (
                <NavLink
                  key={it.to}
                  to={it.to}
                  end={it.to === '/'}
                  className={({ isActive }) =>
                    [s.link, isActive && s.linkActive].filter(Boolean).join(' ')
                  }
                >
                  <Icon name={it.icon} size={17} />
                  <span>{it.label}</span>
                </NavLink>
              ))}
            </div>
          );
        })}
      </nav>
      <div className={s.main}>
        <header className={s.header}>
          <span className={s.perimeter}>
            <Icon name="org" size={14} />
            {user?.orgId ? 'Organizația mea' : 'Toate organizațiile'}
          </span>
          <div className={s.user}>
            <div className="right">
              <div className="strong">{user?.name}</div>
              <div className="tiny muted">{user?.role.name}</div>
            </div>
            <div className={s.avatar} aria-hidden="true">
              {initials}
            </div>
            <Button variant="ghost" small icon="logout" onClick={() => void logout()}>
              Ieșire
            </Button>
          </div>
        </header>
        <main className={s.content}>
          <Outlet />
        </main>
      </div>
      <StepUpDialog />
    </div>
  );
}
